import React, { useState, useEffect } from "react";

import {
  Paper,
  TableRow,
  TableCell,
  Grid,
  Divider,
} from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  DatatablesFooterServerSide,
  IconButtonDatatable,
  ModalDeleteConfirm,
  Title,
  TableCellDefault,
  Loading,
  MasterButton,
} from "App/Component/ui";

import { STYLE_DEFAULT_MASTER } from "App/constants/theme";

import {
  useDatatablesServerSide,
  useDatatables,
  useLocalStorageForm,
} from "App/hooks";
import {
  deletePembelianById,
  getByFilterPembelian,
  headCells,
  ListTotalPembelianFetch,
  RenderStatusPembelianBadge,
  RESET_STATE_FORM_FILTER,
} from "./helpers";
import { PencilIcon, SelectIcon, TrashIcon } from "App/Assets";
import {
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
} from "App/utils/helpers";

import { WMS_FA_DAFTAR_PEMBELIAN, WMS_FA_PEMBELIAN } from "App/constants";
import FormFilterDaftarPembelian from "./FormFilterDaftarPembelian";
import {
  STATUS_OPEN_DRAFT_PEMBELIAN,
  STATUS_PROSES_PEMBELIAN,
  STATUS_SELESAI_PEMBELIAN,
} from "../Pembelian/helpers";
import ListTotalPembelian from "./ListTotalPembelian";
import { FreezeTable } from "components/organism";

export default function DaftarPembelian({
  changeTitle,
  changeParentData,
  changeMenu,
  handleClickMenu,
}) {
  const classes = STYLE_DEFAULT_MASTER();
  const [pembelianID, setPembelianID] = useState(null);
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const handleClickUpdate = async (row) => {
    Promise.resolve()
      .then(() => {
        changeParentData("");
        changeMenu(WMS_FA_PEMBELIAN);
      })
      .then(async () => {
        setPembelianID(row.id);
        await changeParentData({
          id: row?.id,
          idgl: 0,
          date: defaultDateInputDisplay(row?.date),
          is_po: row?.is_po,
          po_id: row?.po_id,
          po_label: "Cari PO",
          gudang_id: row?.gudang_id,
          gudang: row?.gudang,
          unit_id: row?.unit_id,
          unit: row?.nama_unit,
          user: row?.user,
          produsen_id: row?.produsen_id,
          produsen: row?.produsen,
          supplier_id: row?.supplier_id,
          supplier: row?.supiler,
          faktur_no: row?.faktur_no,
          faktur_tgl: defaultDateInputDisplay(row?.faktur_tgl),
          jatuhtempo_tgl: defaultDateInputDisplay(row?.jatuhtempo_tgl),
          kedatangan_tgl: defaultDateInputDisplay(row?.kedatangan_tgl),
          tagih_tgl: defaultDateInputDisplay(row?.tagih_tgl),
          kasbank_id: row?.kasbank_id,
          kasbank: row?.kas_bank,
          status: row?.status_pembelian,
          biayalain: row?.biayalain,
          biayalain2: row?.biayalain,
          ongkos: row?.ongkos,
          ongkos2: row?.ongkos,
          potongan: row?.potongan,
          potongan2: row?.potongan,
          tax: row?.tax,
          tax2: row?.tax,
          sisa: row?.sisa,
          is_changesellprice: row?.is_changesellprice,
          pembayaran: row?.bayar,
          type: "update",
          isOpenDraft: true,
          isProcess: row?.status === 1 ? false : true,
        });

        await changeTitle(WMS_FA_PEMBELIAN);
        await changeMenu(WMS_FA_PEMBELIAN);
        handleClickMenu({
          code: WMS_FA_PEMBELIAN,
          name: "Pembelian",
        });
      });
  };
  const [rows, setRows] = useState([]);
  const [formFilter, setFormFilter] = useLocalStorageForm(
    RESET_STATE_FORM_FILTER,
    WMS_FA_DAFTAR_PEMBELIAN
  );
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const setNewData = async (
    pages = formFilter.pages,
    limit = formFilter.limit
  ) => {
    setLoading(true);
    const res = await getByFilterPembelian(formFilter, pages, limit);
    const list = await ListTotalPembelianFetch(formFilter);
    setData(list);
    if (res.state) {
      setRows(res.data);
      setTotalData(res.meta.count);
      setLoading(false);
    } else {
      setRows([]);
      setLoading(false);
      defaultToastError(res.message);
    }
  };

  const {
    pagination,
    onNext,
    onPrevious,
    handleClickPageNumber,
    handleChangeLimit,
  } = useDatatablesServerSide({ setNewData: setNewData });

  const handleClickDelete = (row) => {
    setPembelianID(row.id);
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  };

  async function deleteList() {
    const res = await deletePembelianById(pembelianID);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  }

  return (
    <>
      <div className={classes.root}>
        <Title title={"Daftar Pembelian Fixed Asset"} />

        {showModalDeleteConfirm && (
          <ModalDeleteConfirm
            confirmHandle={() => deleteList()}
            setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
          />
        )}

        <Paper
          className={classes.paper}
          style={{
            padding: "1rem",
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={6} sm={8}>
              <FormFilterDaftarPembelian
                formFilter={formFilter}
                setFormFilter={setFormFilter}
                setNewData={setNewData}
              />
            </Grid>
            <Grid item xs={6} sm={4}>
              <ListTotalPembelian
                data={data}
                setData={setData}
              />
            </Grid>
          </Grid>
          <Divider />
          <br />
          <Loading show={loading} />
          <TableDaftarPembelian
            rows={rows}
            classes={classes}
            handleClickDelete={handleClickDelete}
            handleClickUpdate={handleClickUpdate}
          />
          <DatatablesFooterServerSide
            totalData={totalData}
            pagination={pagination}
            handleChangeLimit={handleChangeLimit}
            onPrevious={onPrevious}
            onNext={onNext}
            currentPage={pagination.page}
            handleClickPageNumber={handleClickPageNumber}
          />
        </Paper>
      </div>
    </>
  );
}

export const TableDaftarPembelian = ({
  rows,
  classes,
  handleClickUpdate,
  handleClickDelete,
  onlySelect = false,
  handleClickSelect,
}) => {
  const { order, orderBy, handleRequestSort, length } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  });

  const RenderAction = ({ row }) => {
    if (onlySelect) {
      return (
        <>
          <IconButtonDatatable
            color="secondary"
            onClick={() => handleClickSelect(row)}
          >
            <SelectIcon width={"14"} height={"14"} fill={"#fff"} />
          </IconButtonDatatable>
        </>
      );
    } else {
      if (row.status === STATUS_SELESAI_PEMBELIAN || row.status === STATUS_PROSES_PEMBELIAN) {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
             <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
              <PencilIcon />
            </IconButtonDatatable>
          </div>
        );
      } else {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "7px",
            }}
          >
            <IconButtonDatatable onClick={() => handleClickUpdate(row)}>
              <PencilIcon />
            </IconButtonDatatable>

            <IconButtonDatatable onClick={() => handleClickDelete(row)}>
              <TrashIcon />
            </IconButtonDatatable>
          </div>
        );
      }
    }
  };
  // function totalbayar(jumlah, tax, biaya_lain, ongkos, potongan, disc){
  //   let total_tax = (parseFloat(tax) / 100) * (parseFloat(jumlah) - parseFloat(potongan) - parseFloat(disc));
  //   let total = parseFloat(jumlah) + total_tax + parseFloat(biaya_lain) + parseFloat(ongkos) - parseFloat(potongan) - parseFloat(disc);
  //   return total;
  // }
  return (
    <FreezeTable
      headCells={headCells}
      handleRequestSort={handleRequestSort}
      order={order}
      length={length}
      orderBy={orderBy}
    >
          {stableSort(rows, getComparator(order, orderBy)).map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                // style={{
                //   backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                // }}
              >
                <TableCell
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>

                <TableCell
                  scope="row"
                  padding="none"
                  align="center"
                >
                  <RenderAction row={row} />
                </TableCell>
                <TableCell align="left">{row?.id}</TableCell>
                <TableCell align="left">{row?.idgl}</TableCell>
                <TableCell align="left">
                  {isNull(row?.po_id) ? "-" : row?.po_id}
                </TableCell>
                <TableCell align="left">{isNull(row?.nomorPO) ? "-" : row?.nomorPO}</TableCell>
                <TableCell align="left">{isNull(row?.faktur_no) ? "-" : row?.faktur_no}</TableCell>
                <TableCell align="left">
                  <RenderStatusPembelianBadge status={row.status_pembelian} />
                </TableCell>
                <TableCell align="left">
                  {row.status !== STATUS_OPEN_DRAFT_PEMBELIAN && row?.sisa === 0
                    // totalbayar(row.sub_total_pembelian, row.tax, row.biayalain, row.ongkos, row.potongan, row.nilai_discount) === parseFloat(row.bayar) 
                    ? (
                    <MasterButton
                      style={{ borderRadius: 20 }}
                      name={"Lunas"}
                      color={"green"}
                      type="button"
                      disabled
                    />
                  ) : (
                    <MasterButton
                      style={{ borderRadius: 20 }}
                      name={"Belum Lunas"}
                      color={"warning"}
                      type="button"
                      disabled
                    />
                  )}
                </TableCell>
                <TableCell align="left">{row?.nama_unit}</TableCell>
                <TableCell align="left">{row?.gudang}</TableCell>
                <TableCell align="left">{isNull(row?.produsen) ? "-" : row?.produsen}</TableCell>
                <TableCell align="left">{row?.supiler}</TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.faktur_tgl)}
                </TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.jatuhtempo_tgl)}
                </TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.kedatangan_tgl)}
                </TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row?.tagih_tgl)}
                </TableCell>

                <TableCell align="right">
                  {formatNumber(row?.sub_total_pembelian)}
                </TableCell>

                <TableCell align="right">
                  {formatNumber(
                    (row.tax / 100) * (row.sub_total_pembelian - row.nilai_discount - row.potongan)
                  )}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row?.nilai_discount)}
                </TableCell>

                <TableCell align="right">
                  {formatNumber(row?.biayalain)}
                </TableCell>
                <TableCell align="right">{formatNumber(row?.ongkos)}</TableCell>
                <TableCell align="right">{formatNumber(row?.potongan)}</TableCell>
                <TableCell align="right">{formatNumber(row?.bayar)}</TableCell>
                <TableCell align="right">{formatNumber(row?.sisa)}</TableCell>

                <TableCellDefault row={row} type="custom" />
              </TableRow>
            );
          })}
          {rows.length === 0 && (
            <TableRow>
              <TableCell align="center" colSpan={headCells.length}>
                Tidak ada data
              </TableCell>
            </TableRow>
          )}
    </FreezeTable>
  );
};
